import { FB_CAPI_EVENT, FB_META_PIXEL, FB_META_PIXEL_UPDATE, GET_PUBLIC_FB_META_PIXEL, PUBLIC_API_URL, WEBSITE_SETTINGS, WEBSITE_SETTINGS_UPDATE } from '../../../constants/api';
import { ApiInterceptionFetch } from '../api.interceptor';

class FBSettingsService {
    static loadFBMetaPixel = async () => {
        try {
            const response = await ApiInterceptionFetch(`${PUBLIC_API_URL}${FB_META_PIXEL}`, {
                method: 'GET',
            });

            if (!response.ok) {
                const errorData = await response.json();
                // Handle error response here if needed
                // For example, you can log the error or show a notification
                console.error('Error in service:', errorData);
                throw errorData;
            }

            const data = await response.json();
            return data; // Return data for further use if needed
        } catch (error) {
            throw error; // Throw error for handling in components
        }
    };

    static updateFBMetaPixelSettings = async (formData) => {
        try {
            const response = await ApiInterceptionFetch(`${PUBLIC_API_URL}${FB_META_PIXEL_UPDATE}`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                const errorData = await response.json();
                // Handle error response here if needed
                // For example, you can log the error or show a notification
                console.error('Error in service:', errorData);
                throw errorData;
            }

            const data = await response.json();
            return data; // Return data for further use if needed
        } catch (error) {
            throw error; // Throw error for handling in components
        }
    };

    static getFBMetaPixel = async () => {
        try {
            const response = await ApiInterceptionFetch(
                `${PUBLIC_API_URL}${GET_PUBLIC_FB_META_PIXEL}`,
                {
                    method: 'GET',
                },
                false,
            );

            if (!response.ok) {
                const errorData = await response.json();
                // Handle error response here if needed
                // For example, you can log the error or show a notification
                console.error('Error in service:', errorData);
                throw errorData;
            }

            const data = await response.json();
            return data; // Return data for further use if needed
        } catch (error) {
            throw error; // Throw error for handling in components
        }
    };

    // ----------------------------------------
    // Send server-side CAPI event via Laravel
    // ----------------------------------------
    static sendCAPIEvent = async (payload) => {
        try {
            const response = await ApiInterceptionFetch(
                `${PUBLIC_API_URL}${FB_CAPI_EVENT}`,
                {
                    method: 'POST',
                    body: JSON.stringify(payload),
                },
                false,
            );

            if (!response.ok) {
                const errorData = await response.json();
                console.error('CAPI Event error:', errorData);
                throw errorData;
            }

            const data = await response.json();
            return data;
        } catch (error) {
            throw error;
        }
    };
}
export default FBSettingsService;
